import React from 'react';
import { bindActionCreators } from 'redux';
import { AppState } from '@Redux/store';
import { Dispatch } from '@Redux/type';

const Repeater: React.FC<RepeaterProps>  = (props) => {
  const {data, indexPrefix, children} = props;
  
  const elements = [];
  let index = 0;

  for (let item of data) {
    elements.push(
        React.cloneElement(children(item, data.indexOf(item)), {
            key: `${indexPrefix}-${index}`,
        })
    );
    index += 1;
  }

  return (
    <React.Fragment>
        {elements}
    </React.Fragment>
  );
};

const mapStateToProps = (state: AppState, owsProps: any)  => ({
  data: owsProps.data, 
  indexPrefix: owsProps.indexPrefix,
  children: owsProps.children
});

const mapDispatchToProps = (dispatch: Dispatch) => 
  bindActionCreators(
    {
    },
    dispatch
  );

export default Repeater;

type RepeaterProps = ReturnType<typeof mapDispatchToProps> &
ReturnType<typeof mapStateToProps>